/**
 *
 * 珀莱雅
 *
 */

import { getUrlParam } from '../../utils/api';
import { isBuild } from '@/utils/const';

const comein_channel = 'bly';
const comein_channel_logo =
	'https://image.comein.cn/comein-files/img/2023-08-10/8807780d-b56a-47d6-9605-db6ec14d3325/8807780d-b56a-47d6-9605-db6ec14d3325.jpg';
const comein_channel_title = '珀莱雅投资者关系';

export const isThirdParty = getUrlParam().comein_channel === comein_channel;

function getChannelId() {
	return isBuild ? 21289 : 1512;
}

function Bridge() {
	this.title = comein_channel_title;

	this.comein_channel = comein_channel;

	this.authMethod = 1;

	this.menuType = 'tab';
	this.menuTabList = [
		{
			title: '首页',
			path: '/mobile/flagship/index?id=' + getChannelId() + `&comein_channel=${comein_channel}`,
			icon: '#icon-tab_home',
			active_icon: '#icon-tab_home_pre'
		},
		{
			title: '我',
			path: `/mobile/institute/user?comein_channel=${comein_channel}`,
			icon: '#icon-tab_me',
			active_icon: '#icon-tab_me_pre'
		}
	];

	this.instituteUser = {
		showBought: false
	};

	this.bindPhone = {
		// 登录方式，0：手机号，1：邮箱
		loginWay: [0]
	};

	// 小程序审核不过，所以发布的时候隐藏了行情以及公告等tab，审核通过，发布之后再放出来。
	// this.flagship = {
	// 	hideQuotation: true,
	// 	tabList: ["banner"],
	// 	// tabList: [100, 106],
	// }

	this.downloadFile = '/pages/download/index?url=';
}

// 重写第三方页面登陆
Bridge.prototype.login = function () {
	// 设置form，用于登录成功后跳转
	wx.miniProgram.navigateTo({
		url: `/pages/login/index?from=${encodeURIComponent(location.pathname + location.search)}`
	});
};

// 获取分享配置
Bridge.prototype.getShareData = function () {
	return {
		title: comein_channel_title,
		desc: '发现你的美，尽在珀莱雅！',
		link: location.href,
		min_link: '/mobile/flagship/index?id=' + getChannelId() + `&comein_channel=${comein_channel}`,
		img_url: comein_channel_logo,
		min_img_url: comein_channel_logo
	};
};

// 页面跳转 亚厦股份小程序的首页是一个webview、页面跳转的时候需要打开一个新的webview、这时候左上角才会有后退按钮。
Bridge.prototype.navigateTo = function (obj) {
	const url = this.$router.resolve(obj).href;
	wx.miniProgram.navigateTo({
		url: `/pages/index/index?url=${encodeURIComponent(url)}`
	});
};

export default Bridge;
